export default [
  {
    _name: 'CSidebarNav',
    _children: [
      // MAIN
      // {
      //   _name: 'CSidebarNavItem',
      //   name: 'บทความ RFB3',
      //   to: '/rfb3',
      //   icon: 'cil-description'
      // },
      {
        _name: 'CSidebarNavItem',
        name: 'การแจ้งเตือน',
        to: '/notification',
        icon: 'cil-bell'
        // badge: {
        //   color: 'primary',
        //   text: 'NEW'
        // }
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Dashboard',
        to: '/dashboard',
        icon: 'cil-speedometer'
      },
      {
        _name: 'CSidebarNavItem',
        name: 'หนังสือที่ร้องขอ',
        to: '/requestbook',
        icon: 'cil-book'
      },
      // {
      //   _name: 'CSidebarNavDropdown',
      //   name: 'หนังสือที่ร้องขอ',
      //   route: '/requestbook',
      //   icon: 'cil-book',
      //   items: [
      //     {
      //       name: 'ทั้งหมด',
      //       to: '/requestbook/all'
      //     },
      //     {
      //       name: 'ไม่มีในระบบ',
      //       to: '/requestbook/new'
      //     }
      //   ]
      // },
      {
        _name: 'CSidebarNavDropdown',
        name: 'จัดการ',
        route: '/management',
        icon: 'cil-settings',
        items: [
          {
            name: 'หนังสือ',
            to: '/management/book'
          },
          {
            name: 'บทความ',
            to: '/management/article'
          },
          {
            name: 'หนังสือ/บทความ Exporting',
            to: '/management/export'
          },
          {
            name: 'หมวดหมู่หนังสือ',
            to: '/management/book_category'
          },
          {
            name: 'หมวดหมู่บทความ',
            to: '/management/article_category'
          },
          {
            name: 'ผู้ใช้งาน',
            to: '/management/user'
          },
          {
            name: 'คอมเม้นต์',
            to: '/management/comment'
          }
        ]
      }
      // {
      //   _name: 'CSidebarNavDropdown',
      //   name: 'แปลงไฟล์',
      //   route: '/convert',
      //   icon: 'cil-volume-high',
      //   items: [
      //     {
      //       name: 'หนังสือ',
      //       to: '/convert/book'
      //     },
      //     {
      //       name: 'บทความ',
      //       to: '/convert/article'
      //     }
      //   ]
      // },
      // {
      //   _name: 'CSidebarNavDropdown',
      //   name: 'รายงาน',
      //   route: '/report',
      //   icon: 'cil-library',
      //   items: [
      //     {
      //       name: 'การเข้าใช้งานระบบ',
      //       to: '/report/user_log'
      //     },
      //     {
      //       name: 'การร้องขอหนังสือ',
      //       to: '/report/request_book'
      //     },
      //     {
      //       name: 'Report หนังสือ',
      //       to: '/report/book'
      //     }
      //   ]
      // }
    ]
  }
]
